export default [
      {
      path: '/electiveCourse/list',
      name: 'electiveCourse',
      component:resolve => require(['../list/list.vue'],resolve)
    }, 
      {
      path: '/gainCredit',
      name: 'gainCredit',
      component:resolve => require(['../GainCredit/gainCredit.vue'],resolve)
    }, 
    {
      path: '/history',
      name: 'history',
      component:resolve =>  require(['../GainCredit/history.vue'], resolve)
    }
  ]
  
  


// WEBPACK FOOTER //
// ./src/components/electiveCourse/js/index.js